(function () {
  'use strict';

  // ── Hero de destino servido en HLS ─────────────────────────────────────────
  // El vídeo del hero puede venir como playlist HLS (.m3u8). Safari e iOS la
  // reproducen de forma nativa; el resto de navegadores necesitan hls.js.
  //
  // El <video> de HLS no lleva autoplay: el arranque se fuerza desde aquí, una
  // vez la playlist está lista. Y se fija el nivel inicial en el de mayor
  // calidad porque hls.js ordena los niveles de menor a mayor, así que el
  // último es el más alto. Sin fijarlo arrancaría por el más bajo: hasta que no
  // descarga el primer segmento parte de una estimación conservadora de ancho
  // de banda.
  // ──────────────────────────────────────────────────────────────────────────

  var HLS_TYPE = 'application/vnd.apple.mpegurl';

  function play(video) {
    var started = video.play();

    // Si el navegador bloquea la reproducción automática no hay nada que hacer,
    // pero conviene no dejar la promesa sin capturar.
    if (started && started.catch) {
      started.catch(function () {});
    }
  }

  function setupVideo(video, src) {
    // Ojo al orden: hls.js primero. Chrome devuelve "maybe" en canPlayType para
    // este tipo aunque no sepa reproducir HLS, así que comprobar el soporte
    // nativo antes dejaría el vídeo parado en todos los navegadores menos Safari.
    if (typeof Hls === 'undefined' || !Hls.isSupported()) {
      if (video.canPlayType(HLS_TYPE)) {
        video.src = src;
        play(video);
      }
      return;
    }

    var hls = new Hls({ autoStartLoad: false });

    hls.on(Hls.Events.MANIFEST_PARSED, function () {
      hls.startLevel = hls.levels.length - 1;
      hls.startLoad();
      play(video);
    });

    hls.loadSource(src);
    hls.attachMedia(video);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sources = document.querySelectorAll('video source[type="' + HLS_TYPE + '"]');

    for (var i = 0; i < sources.length; i++) {
      setupVideo(sources[i].parentNode, sources[i].getAttribute('src'));
    }
  });
})();
